// extracted by mini-css-extract-plugin
module.exports = {"apps_grid":"apps-grid_apps_grid__1fMrp","apps_icons":"apps-grid_apps_icons__1nalN"};